import type {
  Generated,
  GeneratedAlways,
  Insertable,
  Selectable,
  Updateable,
} from 'kysely';

// Note: Not explicitly defined in DB & could drift over time
export enum VisWorkOrderType {
  MASTER = 'M',
  WORK_ORDER = 'W',
  QUOTE = 'Q',
}

// Note: Not explicitly defined in DB & could drift over time
export enum VisWorkOrderStatus {
  CLOSED = 'C',
  CANCELLED = 'X',
  RELEASED = 'R',
  FIRMED = 'F',
  UNRELEASED = 'U',
}

export interface VisWorkOrderTable {
  act_burden_cost: Generated<number>;
  act_labor_cost: Generated<number>;
  act_material_cost: Generated<number>;
  act_service_cost: Generated<number>;
  allocated_qty: Generated<number>;
  allow_alt_parts: string | null;
  allow_upd_from_leg: Generated<string>;
  allow_upd_from_mst: Generated<string>;
  base_id: string;
  bur_gl_acct_id: string | null;
  close_date: Date | null;
  commodity_code: string | null;
  copy_from_split_id: string | null;
  costed_date: Date | null;
  could_finish_date: Date | null;
  create_date: Generated<Date>;
  customer_priority: Generated<number>;
  dbr_code: number | null;
  dbr_priority: string | null;
  dbr_type: string | null;
  def_lbl_format_id: string | null;
  desired_qty: number | null;
  desired_rls_date: Date | null;
  desired_want_date: Date | null;
  dispatched: string | null;
  drawing_file: string | null;
  drawing_id: string | null;
  drawing_rev_no: string | null;
  ecn_revision: string | null;
  edi_blanket_flag: string | null;
  engineered_by: string | null;
  engineered_date: Date | null;
  entered_by: string | null;
  est_burden_cost: Generated<number>;
  est_labor_cost: Generated<number>;
  est_material_cost: Generated<number>;
  est_service_cost: Generated<number>;
  forward_schedule: Generated<string>;
  fulfilled_qty: Generated<number>;
  global_rank: number | null;
  hard_release_date: string | null;
  inactive: Generated<string>;
  lab_gl_acct_id: string | null;
  lot_id: string;
  marked_for_purge: Generated<string>;
  mat_gl_acct_id: string | null;
  max_qty_complete: Generated<number | null>;
  milestone_seq_no: number | null;
  milestone_sub_id: string | null;
  orig_stage_revision_id: string | null;
  part_id: string | null;
  percent_compl: Generated<string | null>;
  planner_id: string | null;
  posting_candidate: Generated<string>;
  printed_date: Date | null;
  prod_order_type: string | null;
  product_code: string | null;
  qty_compl_by_hrs: Generated<string | null>;
  received_qty: Generated<number>;
  rem_burden_cost: Generated<number>;
  rem_labor_cost: Generated<number>;
  rem_material_cost: Generated<number>;
  rem_service_cost: Generated<number>;
  rowid: GeneratedAlways<number>;
  sched_finish_date: Date | null;
  sched_start_date: Date | null;
  schedule_group_id: string | null;
  ser_gl_acct_id: string | null;
  site_id: string;
  split_id: string;
  status: VisWorkOrderStatus;
  status_eff_date: Generated<Date>;
  sub_id: string;
  type: VisWorkOrderType;
  udf_layout_id: string | null;
  update_date: Date | null;
  update_eng_master: string | null;
  update_from_ref: string | null;
  update_user_id: string | null;
  user_1: string | null;
  user_10: string | null;
  user_2: string | null;
  user_3: string | null;
  user_4: string | null;
  user_5: string | null;
  user_6: string | null;
  user_7: string | null;
  user_8: string | null;
  user_9: string | null;
  variable_table: string | null;
  warehouse_id: string | null;
  wbs_code: string | null;
  wbs_cust_order_id: string | null;
  wbs_project: string | null;
  wip_vas_required: string | null;
}

export type VisWorkOrder = Selectable<VisWorkOrderTable>;
export type VisWorkOrderInsert = Insertable<VisWorkOrderTable>;
export type VisWorkOrderUpdate = Updateable<VisWorkOrderTable>;
